// initial state
import * as base from './base.js'
const baseName = '/admin/api/msg'

const obj = base.setBaseUrl('msg', baseName)
const a = Object.assign(obj)
export default a
